<script setup>
import FaultTree from "../../manageOccurrenceHandling/template/FaultTree.vue";
import { faultTreeMixin } from "../../mixins/faultTreeMixin";
</script>
<template>
    <section>
        <FaultTree class="reasonTreeContainer" :editable="false" :data="reasonTree" :getTree="0"
            @nodeDbClick="setReasonFromTree($event)" />
        <section class="reasonSelected">
            <p>Motivo Selecionado: <span v-if="this.reasonSelected.id">{{ this.reasonSelected.title }}</span></p>
        </section>
        <section class="otherReasonContainer"
            v-if="this.reasonSelected.hasOtherDesc && this.reasonSelected.hasOtherDesc == true">
            <label for="otherReason">Descrição do Motivo:</label>
            <textarea id="otherReason" rows="2" v-model="reasonSelected.reasonOtherDescription"
                placeholder="Descreva o outro motivo aqui."></textarea>
        </section>
        <hr>
        <section class="addButtons">
            <button class="cancel" @click="() => this.$bvModal.hide('selectReasonTree')">{{ this.$t('cancel') }}</button>
            <button @click="applyReason">{{ this.$t('adicionar') }}</button>
        </section>
        
    </section>
</template>
<script>
export default {
    name: "ReasonsToSelect",
    props: ["userObj", "reasonTree", "addReasonFunction"],
    components: { FaultTree },
    mixins: [faultTreeMixin],
    data() {
        return {
            reasonSelected: {},
        }
    },
    methods: {
        setReasonFromTree(event) {
            let reasonObj = {
                title: event.path,
                id: event.node.id,
                reasonTreeId: event.node.id,
                createdBy: this.userObj.Id,
                hasOtherDesc: event.node.data.text.toLowerCase() == 'outros' || event.node.data.text.toLowerCase() == 'outro' || event.node.data.text.toLowerCase().includes('outro') ? true : false,
                reasonOtherDescription: '',
                actions: [],
            }

            this.reasonSelected = {...reasonObj};
        },

        applyReason() {
            if (!this.reasonSelected.id || (this.reasonSelected.hasOtherDesc == true && this.reasonSelected.reasonOtherDescription == '')) {
                this.$bvToast.toast('Selecione um motivo antes de adicionar.', {
                    title: 'Descrição vazia.',
                    variant: 'warning',
                    toaster: 'b-toaster-bottom-left',
                    solid: true
                });

                return;
            }

            if (this.reasonSelected.hasOtherDesc == true) this.reasonSelected.title += ` : ${this.reasonSelected.reasonOtherDescription}`;

            this.addReasonFunction(this.reasonSelected);
            this.$bvModal.hide('selectReasonTree');
        }
    },
}
</script>
<style scoped>
.reasonTreeContainer {
    padding: 0.3rem;
    border: 1px solid #bebebe;
    border-radius: 0.2rem;
    height: 22rem;
}

.reasonSelected {
    display: flex;
    align-items: center;
    column-gap: 0.3rem;
    margin-top: 0.5rem;
}

.reasonSelected p {
    font-weight: bold;
    margin: 0;
}

.reasonSelected span {
    font-weight: normal;
}

.otherReasonContainer {
    margin-top: 0.8rem;
}

.otherReasonContainer label {
    font-weight: bold;
}

.otherReasonContainer textarea {
    width: 100%;
}

.addButtons{
    margin-top: 1rem;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    column-gap: 1rem;
}

.addButtons button{
    font-weight: bold;
    padding: 0.4rem 0.5rem;
    color: white;
    background-color: #ff5f00;
    border: none;
    border-radius: 0.2rem;
}

.addButtons .cancel{
    background-color: #5a6268;
}
</style>